<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-3 mt-md-0 mt-4">
        <app-list-header
          [title]="'SUPPORT_TICKET.Ticket_List' | translate"
          icon="bx bx-support"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>
    <!-- Body Content -->
    <div class="col-md-12">
      <div class="row">
        <div class="col-xl-8 mb-3">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body p-3 p-md-4 pb-md-0">
              <!-- Search Filters -->
              <div class="search-section compact-inputs dropdown-pd-none">
                <div class="row g-2 align-items-center mb-3">
                  <!-- Ticket ID Search -->
                  <div class="col-md-6 mb-2 px-1">
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <div class="flex-grow-1">
                        <mat-form-field
                          appearance="outline"
                          subscriptSizing="dynamic"
                          class="w-100"
                        >
                          <mat-label>{{
                            "SUPPORT_TICKET.Enter_Ticket_ID" | translate
                          }}</mat-label>
                          <input
                            matInput
                            [(ngModel)]="form.searchParams['id']"
                            id="id"
                            name="id"
                            type="text"
                          />
                        </mat-form-field>
                      </div>
                      <button
                        mat-icon-button
                        class="icon-center icon-clean ms-1"
                        [matTooltip]="
                          'SUPPORT_TICKET.Enter_Ticket_ID' | translate
                        "
                      >
                        <mat-icon class="text-secondary icon-compact"
                          >info</mat-icon
                        >
                      </button>
                    </div>
                  </div>
                  <!-- Title Search -->
                  <div class="col-md-6 mb-2 px-1">
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <div class="flex-grow-1">
                        <mat-form-field
                          appearance="outline"
                          subscriptSizing="dynamic"
                          class="w-100"
                        >
                          <mat-label>{{
                            "SUPPORT_TICKET.Enter_title" | translate
                          }}</mat-label>
                          <input
                            matInput
                            [(ngModel)]="form.searchParams['title']"
                            id="title"
                            name="title"
                            type="text"
                          />
                        </mat-form-field>
                      </div>
                      <button
                        mat-icon-button
                        class="icon-center icon-clean ms-1"
                        [matTooltip]="'SUPPORT_TICKET.Enter_title' | translate"
                      >
                        <mat-icon class="text-secondary icon-compact"
                          >info</mat-icon
                        >
                      </button>
                    </div>
                  </div>
                  <!-- Date Search -->
                  <div class="col-md-6 mb-2 px-1">
                    <div
                      class="d-flex justify-content-start align-items-center"
                    >
                      <div class="flex-grow-1">
                        <mat-form-field
                          appearance="outline"
                          subscriptSizing="dynamic"
                          class="w-100"
                        >
                          <mat-label>{{
                            "SUPPORT_TICKET.Enter_date" | translate
                          }}</mat-label>
                          <input
                            matInput
                            [(ngModel)]="form.searchParams['createdDate']"
                            id="createdDate"
                            name="createdDate"
                            type="date"
                            #datePicker
                          />
                          <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            class="icon-pd-none"
                            (click)="datePicker.showPicker()"
                            aria-label="Open date picker"
                          >
                            <mat-icon class="icon-compact text-secondary"
                              >calendar_today</mat-icon
                            >
                          </button>
                        </mat-form-field>
                      </div>
                      <button
                        mat-icon-button
                        class="icon-center icon-clean ms-1"
                        [matTooltip]="'SUPPORT_TICKET.Enter_date' | translate"
                      >
                        <mat-icon class="text-secondary icon-compact"
                          >info</mat-icon
                        >
                      </button>
                    </div>
                  </div>
                  <!-- Status Filter Buttons -->
                  <div class="col-auto mb-2 px-1">
                    <button
                      mat-stroked-button
                      (click)="searchOpen()"
                      color="primary"
                      [color]="
                        form.searchParams['status'] === 'Open' ? 'primary' : ''
                      "
                      [class.search-btn-marked]="
                        form.searchParams['status'] === 'Open'
                      "
                      class="status-btn"
                    >
                      <i class="fas fa-folder-open"></i>
                      <span class="ms-2">{{
                        "SUPPORT_TICKET.Open" | translate
                      }}</span>
                    </button>
                  </div>
                  <div class="col-auto mb-2 px-1">
                    <button
                      mat-stroked-button
                      (click)="searchDraft()"
                      color="primary"
                      [color]="
                        form.searchParams['status'] === 'Draft' ? 'primary' : ''
                      "
                      [class.search-btn-marked]="
                        form.searchParams['status'] === 'Draft'
                      "
                      class="status-btn"
                    >
                      <i class="fas fa-file-signature"></i>
                      <span class="ms-2">{{
                        "SUPPORT_TICKET.Draft" | translate
                      }}</span>
                    </button>
                  </div>
                  <div class="col-auto mb-2 px-1">
                    <button
                      mat-stroked-button
                      (click)="searchClose()"
                      color="primary"
                      [color]="
                        form.searchParams['status'] === 'Close' ? 'primary' : ''
                      "
                      [class.search-btn-marked]="
                        form.searchParams['status'] === 'Close'
                      "
                      class="status-btn"
                    >
                      <mat-icon>block</mat-icon>
                      <span>{{ "SUPPORT_TICKET.Close" | translate }}</span>
                    </button>
                  </div>
                  <div class="col-auto mb-2 px-1">
                    <button
                      mat-stroked-button
                      (click)="searcInProgress()"
                      [color]="
                        form.searchParams['status'] === 'In Progress'
                          ? 'primary'
                          : ''
                      "
                      [class.search-btn-marked]="
                        form.searchParams['status'] === 'In Progress'
                      "
                      class="status-btn"
                    >
                      <mat-icon>pending</mat-icon>
                      <span>{{
                        "SUPPORT_TICKET.In_Progress" | translate
                      }}</span>
                    </button>
                  </div>
                  <!-- Search Button -->
                  <div class="col-auto mb-2 px-1">
                    <button
                      *ngIf="!isSupportAdmin"
                      mat-stroked-button
                      color="primary"
                      (click)="searchById(); search()"
                      class="action-btn"
                      [matTooltip]="'COMMON.SEARCH' | translate"
                    >
                      <mat-icon>search</mat-icon>
                      <span>{{ "COMMON.SEARCH" | translate }}</span>
                    </button>
                    <button
                      *ngIf="isSupportAdmin"
                      mat-stroked-button
                      color="primary"
                      (click)="adminSearch()"
                      class="action-btn"
                      [matTooltip]="'COMMON.SEARCH' | translate"
                    >
                      <mat-icon>search</mat-icon>
                      <span>{{ "COMMON.SEARCH" | translate }}</span>
                    </button>
                  </div>
                  <!-- Reset Button -->
                  <div class="col-auto mb-2 px-1">
                    <button
                      mat-stroked-button
                      color="primary"
                      (click)="resetSearchForm()"
                      class="action-btn"
                      id="marginSet"
                      [matTooltip]="'COMMON.RESET' | translate"
                    >
                      <i class="fa fa-eraser"></i>
                      <span class="ms-2">{{ "COMMON.RESET" | translate }}</span>
                    </button>
                  </div>
                  <!-- New Ticket Button -->
                  <div class="col-auto mb-2 px-1">
                    <button
                      mat-stroked-button
                      color="primary"
                      (click)="resetForm()"
                      class="action-btn"
                      [matTooltip]="'SUPPORT_TICKET.New' | translate"
                    >
                      <mat-icon>add</mat-icon>
                      <span>{{ "SUPPORT_TICKET.New" | translate }}</span>
                    </button>
                  </div>
                </div>
                <!-- Search Messages -->
                <div>
                  <div>
                    <p
                      *ngIf="
                        form['searchError'] == false && form['searchMessage']
                      "
                    >
                      <app-ncs-alert
                        [message]="form['searchMessage']"
                        type="success"
                      />
                    </p>
                    <p
                      *ngIf="
                        form['searchError'] == true && form['searchMessage']
                      "
                    >
                      <app-ncs-alert
                        [message]="form['searchMessage']"
                        type="danger"
                      />
                    </p>
                  </div>

                  <!-- Ticket List -->
                  <div class="row">
                    <div class="col-12">
                      <div
                        *ngFor="let e of visibleList; let i = index"
                        class="card border-0 shadow-sm mb-3"
                      >
                        <div class="card-body ticket-list-body p-3">
                          <div class="row g-3 align-items-center">
                            <div class="col-lg-8 col-md-7">
                              <div class="d-flex align-items-start gap-3">
                                <div
                                  class="ticket-index bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold"
                                  style="
                                    width: 25px;
                                    height: 25px;
                                    min-width: 25px;
                                    font-size: 0.75rem;
                                  "
                                >
                                  {{ pageIndex(i) }}
                                </div>
                                <div class="flex-grow-1">
                                  <div
                                    class="d-flex flex-wrap align-items-center gap-2 mb-1"
                                  >
                                    <div
                                      class="mb-0 fw-bold cursor-pointer text-dark"
                                    >
                                      <span
                                        class="text-primary-emphasis opacity-75"
                                        ><span>#</span> {{ e.id }}</span
                                      >
                                      <div class="mt-1 mb-0 text-secondary">
                                        <i class="fa fa-file"></i>
                                        {{ transform(e.title, 45) }}
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <div
                                      class="text-muted mt-2"
                                      style="font-size: 0.8rem"
                                    >
                                      <span class="fw-semibold">{{
                                        "SUPPORT_TICKET.Created:" | translate
                                      }}</span>
                                      {{ e.createdDate | date: "dd/MM/yyyy" }}
                                      <span class="opacity-75">{{
                                        e.createdTime
                                      }}</span>
                                    </div>
                                    <div
                                      class="text-muted mt-1"
                                      style="font-size: 0.8rem"
                                    >
                                      <span class="fw-semibold">{{
                                        "SUPPORT_TICKET.Closed:" | translate
                                      }}</span>
                                      {{ e.closeDate | date: "dd/MM/yyyy" }}
                                      <span class="opacity-75">{{
                                        e.closeTime
                                      }}</span>
                                    </div>
                                  </div>
                                  <div class="d-inline-flex gap-1 pt-3">
                                    <span
                                      *ngIf="e.category === 'Requirements'"
                                      class="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle"
                                    >
                                      <i class="bi bi-file-text me-1"></i
                                      >{{ e.category }}
                                    </span>
                                    <span
                                      *ngIf="e.category === 'Help'"
                                      class="badge rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle"
                                    >
                                      <i class="fas fa-question-circle me-1"></i
                                      >{{ e.category }}
                                    </span>
                                    <span
                                      *ngIf="e.category === 'Issue'"
                                      class="badge rounded-pill bg-danger-subtle text-danger border border-danger-subtle"
                                    >
                                      <i
                                        class="fas fa-exclamation-circle me-1"
                                      ></i
                                      >{{ e.category }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col-md-5">
                              <div
                                class="d-flex flex-row flex-md-column justify-content-between align-items-center align-items-md-end h-100 gap-2"
                              >
                                <div class="mb-md-auto">
                                  <span
                                    *ngIf="e.status === 'Draft'"
                                    class="badge bg-light text-primary border px-3 py-2 rounded-pill"
                                  >
                                    <i class="fas fa-file-signature me-1"></i
                                    >{{ "SUPPORT_TICKET.Draft" | translate }}
                                  </span>
                                  <span
                                    *ngIf="e.status === 'Open'"
                                    class="badge bg-info-subtle text-info-emphasis border border-info-subtle px-3 py-2 rounded-pill"
                                  >
                                    <i class="fas fa-folder-open me-1"></i
                                    >{{ "SUPPORT_TICKET.Open" | translate }}
                                  </span>
                                  <span
                                    *ngIf="e.status === 'Close'"
                                    class="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill"
                                  >
                                    <i class="fas fa-check-circle me-1"></i
                                    >{{ "SUPPORT_TICKET.Close" | translate }}
                                  </span>
                                  <span
                                    *ngIf="e.status === 'In Progress'"
                                    class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-2 rounded-pill"
                                  >
                                    <i class="fas fa-spinner fa-spin me-1"></i
                                    >{{
                                      "SUPPORT_TICKET.In_Progress" | translate
                                    }}
                                  </span>
                                </div>

                                <div
                                  class="btn-group shadow-sm bg-light rounded p-2"
                                  role="group"
                                >
                                  <button
                                    (click)="searchComment(e)"
                                    mat-icon-button
                                    data-bs-toggle="modal"
                                    data-bs-target="#commentModal"
                                    class="icon-pd-none"
                                    color="primary"
                                    [matTooltip]="
                                      'SUPPORT_TICKET.Comment' | translate
                                    "
                                  >
                                    <i class="bi bi-reply-fill"></i>
                                  </button>

                                  <button
                                    *ngIf="
                                      e.status === 'Draft' || isSupportAdmin
                                    "
                                    (click)="get(e.id)"
                                    mat-icon-button
                                    class="icon-pd-none ms-2"
                                    color="primary"
                                    [matTooltip]="
                                      'SUPPORT_TICKET.Edit' | translate
                                    "
                                  >
                                    <mat-icon class="icon-compact"
                                      >edit</mat-icon
                                    >
                                  </button>

                                  <button
                                    *ngIf="
                                      e.status != 'Draft' && !isSupportAdmin
                                    "
                                    (click)="getView(e.id, 'view')"
                                    mat-icon-button
                                    class="icon-pd-none ms-3"
                                    color="primary"
                                    [matTooltip]="
                                      'SUPPORT_TICKET.View' | translate
                                    "
                                  >
                                    <mat-icon class="icon-compact"
                                      >visibility</mat-icon
                                    >
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- No Tickets Found -->
                      <div
                        *ngIf="!visibleList || visibleList.length === 0"
                        class="card border-0 shadow-sm text-center py-5 mt-3"
                      >
                        <div class="card-body">
                          <div class="mb-4">
                            <div
                              class="bg-light d-inline-block rounded-circle p-4"
                            >
                              <mat-icon
                                class="text-muted opacity-50"
                                style="
                                  font-size: 3rem;
                                  width: 3rem;
                                  height: 3rem;
                                "
                              >
                                confirmation_number
                              </mat-icon>
                            </div>
                          </div>
                          <h5 class="fw-bold text-dark mb-2">
                            {{ "SUPPORT_TICKET.No_Tickets_Found" | translate }}
                          </h5>
                          <p
                            class="text-muted mx-auto mb-0"
                            style="max-width: 300px"
                          >
                            {{
                              "SUPPORT_TICKET.Create_your_first_ticket"
                                | translate
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 mb-3">
          <div
            class="card shadow-sm border-0 compact-inputs position-sticky sticky-xl-top"
            style="top: 4.5rem; z-index: 0"
          >
            <div class="card-header">
              <h6 class="modal-title" id="exampleModalLabel">
                {{ "SUPPORT_TICKET.Ticket" | translate }}
              </h6>
            </div>
            <div class="card-body p-3 p-md-4">
              <form class="form-horizontal" role="form" #uiForm="ngForm">
                <!--Form Message -->
                <p *ngIf="form['error'] == false && form['message']">
                  <app-ncs-alert [message]="form['message']" type="success" />
                </p>
                <p *ngIf="form['error'] == true && form['message']">
                  <app-ncs-alert [message]="form['message']" type="danger" />
                </p>

                <!-- Title Field -->
                <div class="mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{
                      "SUPPORT_TICKET.Title:" | translate
                    }}</mat-label>
                    <input
                      matInput
                      [readonly]="mode === 'view' || isSupportAdmin"
                      required
                      [(ngModel)]="form.data['title']"
                      id="title"
                      name="title"
                      type="text"
                    />
                  </mat-form-field>
                </div>

                <!-- Category Field -->
                <div class="mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{
                      "SUPPORT_TICKET.Category:" | translate
                    }}</mat-label>
                    <mat-select
                      required
                      [(ngModel)]="form.data['category']"
                      [disabled]="mode === 'view' || isSupportAdmin"
                      id="category"
                      name="category"
                    >
                      <mat-option [value]="undefined">
                        {{ "SUPPORT_TICKET.Select_Category" | translate }}
                      </mat-option>
                      <ng-container *ngFor="let e of attributeList">
                        <ng-container
                          *ngIf="e['type'] === 'list' && e.code === 'category'"
                        >
                          <mat-option *ngFor="let c of e['values']" [value]="c">
                            {{ c }}
                          </mat-option>
                        </ng-container>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Description Field -->
                <div class="mb-2 textarea-container">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{
                      "SUPPORT_TICKET.Description:" | translate
                    }}</mat-label>
                    <textarea
                      matInput
                      [readonly]="mode === 'view' || isSupportAdmin"
                      required
                      [(ngModel)]="form.data['description']"
                      id="description"
                      name="description"
                      rows="6"
                    >
                    </textarea>
                  </mat-form-field>
                </div>

                <div class="" *ngIf="uiForm.valid">
                  <div
                    class="mb-2"
                    *ngIf="!form.data['id'] || form.data['status'] === 'Draft'"
                  >
                    <mat-label
                      >{{ "SUPPORT_TICKET.Image:" | translate }}
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      #file
                      type="file"
                      id="imageId"
                      accept="image/*"
                      name="imageId"
                      style="display: none"
                      (change)="file.files && onFileChanged($event)"
                    />
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        readonly
                        [value]="
                          file.files && file.files.length > 0
                            ? file.files[0].name
                            : ''
                        "
                        placeholder="{{ 'PROFILE.SELECT_IMAGE' | translate }}"
                        (click)="mode !== 'view' && file.click()"
                        style="cursor: pointer"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        [disabled]="mode === 'view'"
                        (click)="file.click()"
                        class="icon-pd-none"
                      >
                        <mat-icon class="text-secondary icon-compact"
                          >attach_file</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- Image Preview -->
                  <div class="mb-4">
                    <div class="col-12 text-center">
                      <a
                        href="{{ getDoc(form.data['imageId']) }}"
                        target="_blank"
                      >
                        <img
                          [src]="
                            imagePreview == null
                              ? getDocThumbnail(form.data['imageId'])
                              : imagePreview
                          "
                          alt="Image Preview"
                          class="img-thumbnail"
                          style="max-height: 200px"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </form>

              <!-- Action Buttons -->
              <div
                *ngIf="!isSupportAdmin"
                class="d-flex justify-content-center align-items-center flex-wrap gap-2"
              >
                <button
                  *ngIf="form.data.status === 'Draft' || !form.data?.status"
                  mat-stroked-button
                  color="primary"
                  [disabled]="!uiForm.valid"
                  (click)="saveSupport()"
                >
                  <i class="fas fa-file-signature"></i>
                  {{ "SUPPORT_TICKET.Save_as_Draft" | translate }}
                </button>
                <button
                  *ngIf="form.data.status === 'Draft' || !form.data.id"
                  mat-stroked-button
                  color="primary"
                  [disabled]="!uiForm.valid"
                  (click)="summitSupport()"
                >
                  <mat-icon>save</mat-icon>
                  {{ "SUPPORT_TICKET.Submit" | translate }}
                </button>
                <button
                  *ngIf="form.data.status === 'Draft' && !isSupportAdmin"
                  mat-stroked-button
                  color="warn"
                  class=""
                  (click)="delete(form.data.id)"
                >
                  <mat-icon class="icon-compact">delete</mat-icon>
                  <span>Delete </span>
                </button>
              </div>

              <!-- Comment Section (Admin Only) -->
              <div class="" *ngIf="isSupportAdmin">
                <!--comment message -->
                <p
                  *ngIf="
                    commentform['error'] == false && commentform['message']
                  "
                >
                  <app-ncs-alert
                    [message]="commentform['message']"
                    type="success"
                  />
                </p>
                <p
                  *ngIf="commentform['error'] == true && commentform['message']"
                >
                  <app-ncs-alert
                    [message]="commentform['message']"
                    type="danger"
                  />
                </p>

                <!--comment input form -->
                <div *ngIf="form.data['id'] > 0">
                  <!-- Status Field -->
                  <div class="mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "SUPPORT_TICKET.Status:" | translate
                      }}</mat-label>
                      <mat-select
                        required
                        [(ngModel)]="form.data['status']"
                        (selectionChange)="setCommentStatus()"
                        id="status"
                        name="status"
                      >
                        <mat-option [value]="undefined" disabled>
                          {{ "SUPPORT_TICKET.Select Status" | translate }}
                        </mat-option>
                        <mat-option value="Open" disabled>{{
                          "SUPPORT_TICKET.Open" | translate
                        }}</mat-option>
                        <mat-option value="Draft" disabled>{{
                          "SUPPORT_TICKET.Draft" | translate
                        }}</mat-option>
                        <mat-option value="Close">{{
                          "SUPPORT_TICKET.Close" | translate
                        }}</mat-option>
                        <mat-option value="In Progress">{{
                          "SUPPORT_TICKET.In_Progress" | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div
                    class=""
                    *ngIf="
                      form.data['status'] === 'Close' ||
                      form.data['status'] === 'In Progress'
                    "
                  >
                    <!-- Comments Field -->
                    <div class="mb-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{
                          "SUPPORT_TICKET.Comments:" | translate
                        }}</mat-label>
                        <textarea
                          matInput
                          required
                          [(ngModel)]="commentform.data['comment']"
                          id="comment"
                          name="comment"
                          rows="6"
                          [placeholder]="
                            'SUPPORT_TICKET.Enter_description' | translate
                          "
                        >
                        </textarea>
                      </mat-form-field>
                    </div>

                    <!-- Comment File Upload -->
                    <div class="mb-3">
                      <label
                        for="description"
                        class="col col-form-label col-form-label-sm"
                      >
                        {{ "SUPPORT_TICKET.Image:" | translate }}
                      </label>
                      <div class="col">
                        <input
                          class="form-control"
                          id="commentImageId"
                          #filed
                          type="file"
                          accept="image/*"
                          name="commentImageId"
                          (click)="filed.click()"
                          (change)="filed.files && onCommentFileChanged($event)"
                        />
                      </div>
                    </div>

                    <!-- Comment Image Preview -->
                    <div class="mb-4">
                      <div class="col-sm-3"></div>
                      <div class="col-sm-9 text-secondary">
                        <a
                          href="{{ getDoc(commentform.data['imageId']) }}"
                          target="_blank"
                        >
                          <img
                            [src]="
                              imageCommentPreview == null
                                ? getDocThumbnail(commentform.data['imageId'])
                                : imageCommentPreview
                            "
                            alt="Image Preview"
                            class="img-thumbnail"
                            style="max-width: 200px; max-height: 200px"
                          />
                        </a>
                      </div>
                    </div>

                    <!-- Submit Comment Button -->
                    <div
                      class="d-flex justify-content-center align-items-center align-middle"
                    >
                      <button
                        mat-stroked-button
                        color="primary"
                        class="btn-sm ms-1 no-wrap"
                        [disabled]="!uiForm.valid"
                        (click)="saveComment()"
                      >
                        <mat-icon class="me-1">save</mat-icon>
                        {{ "SUPPORT_TICKET.Submit" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Model Popup -->
<div
  class="modal fade"
  id="commentModal"
  data-bs-keyboard="false"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "SUPPORT_TICKET.Reply" | translate }} -
          {{ selectedSupport["id"] }} - {{ selectedSupport["title"] }} -
          {{ selectedSupport["status"] }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'Close' | translate"
          [title]="'SUPPORT_TICKET.Close' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <p
          *ngIf="
            commentform['searchError'] == false && commentform['searchMessage']
          "
        >
          <app-ncs-alert
            [message]="commentform['searchMessage']"
            type="success"
          />
        </p>
        <p
          *ngIf="
            commentform['searchError'] == true && commentform['searchMessage']
          "
        >
          <app-ncs-alert
            [message]="commentform['searchMessage']"
            type="danger"
          />
        </p>
        <!-- table form -->
        <div class="table-responsive mt-3 mb-3">
          <p *ngIf="form['searchError'] == false && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="success" />
          </p>
          <p *ngIf="form['searchError'] == true && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="danger" />
          </p>
          <div class="table-container mb-3">
            <div class="table-responsive table-scrollable">
              <table class="table table-bordered table-sticky-header">
                <thead>
                  <tr>
                    <th>{{ "SUPPORT_TICKET.S.No." | translate }}</th>
                    <th>{{ "SUPPORT_TICKET.Comment" | translate }}</th>
                    <th>{{ "SUPPORT_TICKET.Ticket Status" | translate }}</th>
                    <th>{{ "SUPPORT_TICKET.User" | translate }}</th>
                    <th>{{ "SUPPORT_TICKET.Date" | translate }}</th>
                    <th>{{ "SUPPORT_TICKET.Image" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let e of commentform.list; let i = index">
                    <td>{{ pageIndex(i) }}</td>
                    <td>{{ e["comment"] }}</td>
                    <td>{{ e["ticketStatus"] }}</td>
                    <td>{{ e["userFirstname"] }}</td>
                    <td>
                      {{ e["createdDatetime"] | date: "dd/MM/yyyy hh:mm a" }}
                    </td>
                    <td>
                      <span *ngIf="e['imageId']">
                        <a href="{{ getDoc(e.imageId) }}" target="_blank">
                          <img
                            src="{{ getDocThumbnail(e.imageId) }}"
                            width="75px"
                          />
                        </a>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
          [attr.aria-label]="'SUPPORT_TICKET.Close' | translate"
          [title]="'SUPPORT_TICKET.Close' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "SUPPORT_TICKET.Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>